import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, Input, Modal, Spin } from 'antd';
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  CloseOutlined,
  DeleteOutlined,
} from '@ant-design/icons';
import styled from '@emotion/styled';
import {
  Container,
  FormWrapper,
  PrimaryButtonV2,
  SecondaryButton,
  SpaceBetween,
  formLayout,
  formValidateMessages,
} from 'utils';
import { ProjectsActions } from 'redux/actions';
import SupportInfoModal from './Support.Info.modal';

const FormItem = Form.Item;
const MAX_SUPPORT_LEVELS = 8;

const AddTextArea = styled(Input.TextArea)`
  .ant-input {
    font-size: 16px;
    padding-top: 7px;
  }
`;
const SmallHelper = styled.div`
  /* Heading */
  
  /* Text sm/Regular */
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 30px;
  /* or 143% */
  text-align: center;

  color: #717680;
  
`;

const SmallModalLink = styled.div`
  /* Heading */
  

  /* Text md/Regular */
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  text-decoration-line: underline;

  color: #9dbc60;

  cursor: pointer;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  width: 100%;

`;

const HeadingBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
`;

const PageTitle = styled.h1`
  margin: 0;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 30px;
  line-height: 38px;
  color: #181d27;
`;

const PageText = styled.p`
  margin: 0;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  color: #535862;
`;

const SmallText = styled.div`
  margin: 0;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #535862;

  ul {
    margin: 0;
    padding-left: 24px;
  }
`;

const SupportList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  margin-bottom:24px
`;

const SupportCard = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  gap: 4px;
  width: 100%;
  min-width: 320px;
  min-height: 136px;
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  position: relative;
`;

const SupportPrice = styled.div`
  width: 100%;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: #181d27;
`;

const SupportContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  width: 100%;
`;

const SupportTitle = styled.div`
  width: 100%;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #181d27;
`;

const SupportDescription = styled.div`
  width: 100%;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #656565;
`;

const SupportBookedText = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #717680;
`;

const CardDeleteButton = styled.button`
  position: absolute;
  right: 12px;
  top: 12px;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  color: #a4a7ae;
  cursor: pointer;
  display: ${({ $visible }) => ($visible ? 'inline-flex' : 'none')};
  align-items: center;
  justify-content: center;
  border-radius: 8px;

  &:hover {
    background: #f5f5f5;
    color: #d92d20;
  }
`;

const AddButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 100%;
  justify-content: center;
  
`;

const AddLimitText = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #717680;
  text-align: center;
`;

const AddButton = styled.button`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 48px;
  width: 293px;
  max-width: 100%;
  padding: 12px 18px;
  gap: 6px;
  background: #ffffff;
  border: 1px solid #d5d7da;
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05),
    inset 0px 0px 0px 1px rgba(10, 13, 18, 0.18),
    inset 0px -2px 0px rgba(10, 13, 18, 0.05);
  border-radius: 8px;
  cursor: pointer;

  span {
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #414651;
  }

  &:hover {
    background: #f9fafb;
  }
`;

const ModalTitle = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: #181d27;
`;

const ModalFormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Label = styled.label`
  display: flex;
  gap: 4px;
  margin-bottom: 8px;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #414651;
`;

const Required = styled.span`
  color: #9dbc60;
`;

const StyledInput = styled(Input)`
  height: 52px;
  border-radius: 8px;
  border: 1px solid #d5d7da;
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05);
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  color: #181d27;

  &::placeholder {
    color: #717680;
  }
`;

const PriceInputGroup = styled.div`
  display: flex;
  width: 100%;

  .currency {
    width: 66px;
    height: 52px;
    border: 1px solid #d5d7da;
    border-right: none;
    border-radius: 8px 0 0 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    color: #535862;
    background: #ffffff;
  }

  input {
    border-radius: 0 8px 8px 0 !important;
  }
`;

const StyledTextArea = styled(Input.TextArea)`
  border-radius: 8px !important;
  border: 1px solid #d5d7da !important;
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05);
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  color: #181d27;

  &::placeholder {
    color: #717680;
  }
`;

const ModalActions = styled.div`
  display: flex;
  gap: 14px;
  width: 100%;
  margin-top: 28px;
`;

const CancelButton = styled.button`
  flex: 1;
  height: 52px;
  border-radius: 8px;
  border: 1px solid #d5d7da;
  background: #ffffff;
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05),
    inset 0px 0px 0px 1px rgba(10, 13, 18, 0.18),
    inset 0px -2px 0px rgba(10, 13, 18, 0.05);
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #414651;
`;

const ConfirmButton = styled.button`
  flex: 1;
  height: 52px;
  border-radius: 8px;
  border: 1px solid #8faa50;
  background: #9dbc60;
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05),
    inset 0px 0px 0px 1px rgba(10, 13, 18, 0.18),
    inset 0px -2px 0px rgba(10, 13, 18, 0.05);
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #ffffff;

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

class SupportLevels extends Component {
  static propTypes = {
    project: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    projectId: PropTypes.string,
    updateDraft: PropTypes.func.isRequired,
    handleSteps: PropTypes.func.isRequired,
    setCanMove: PropTypes.func.isRequired,
    editProject: PropTypes.bool,
    handleExitEditForm: PropTypes.func,
  };

  constructor(props) {
    super(props);

    const existingLevels =
      props.project?.support_levels || [];

    this.formRef = React.createRef();
    this.modalFormRef = React.createRef();

    this.state = {
      showInfoModal: false,
      supportLevels: existingLevels.length
        ? existingLevels.map((item, index) => ({
            id: item.id || `${Date.now()}-${index}`,
            title: item.title || '',
            price: item.price || item.amount || '',
            description: item.description || '',
            booked: Number(item.booked || 0),
          })) : [],
      modalOpen: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.project !== this.props.project) {
      const existingLevels =
        this.props.project?.support_levels || [];
      
      if (existingLevels.length) {
        this.setState({
          supportLevels: existingLevels.map((item, index) => ({
            id: item.id || `${Date.now()}-${index}`,
            title: item.title || '',
            price: item.price || item.amount || '',
            description: item.description || '',
            booked: Number(item.booked || 0),
          })),
        });
      }
    }
  }

  formatPrice = (price) => {
    const normalized = String(price || '')
      .replace('€', '')
      .replace(/\s/g, '')
      .replace(',', '.');

    const number = Number(normalized);

    if (Number.isNaN(number)) {
      return `${price} €`;
    }

    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
    }).format(number);
  };

  openModal = () => {
    if (this.state.supportLevels.length >= MAX_SUPPORT_LEVELS) {
      return;
    }

    this.setState({ modalOpen: true }, () => {
      this.modalFormRef.current?.resetFields();
    });
  };

  closeModal = () => {
    this.setState({ modalOpen: false });
  };

  addSupportLevel = async () => {
    if (this.state.supportLevels.length >= MAX_SUPPORT_LEVELS) {
      this.setState({ modalOpen: false });
      return;
    }

    try {
      const values = await this.modalFormRef.current.validateFields();

      const newLevel = {
        id: `${Date.now()}`,
        title: values.title,
        price: values.price,
        description: values.description || '',
        booked: 0,
      };

      this.setState(
        (prevState) => ({
          supportLevels: [...prevState.supportLevels, newLevel],
          modalOpen: false,
        }),
        () => {
          this.props.setCanMove(false);
          this.modalFormRef.current?.resetFields();
        }
      );
    } catch (error) {
      return null;
    }
  };

  removeSupportLevel = (id) => {
    this.setState(
      (prevState) => ({
        supportLevels: prevState.supportLevels.filter((item) => item.id !== id),
      }),
      () => {
        this.props.setCanMove(false);
      }
    );
  };

  handleReturn = () => {
    if (this.props.editProject && this.props.handleExitEditForm) {
      this.props.handleExitEditForm();
      return;
    }

    this.props.handleSteps(6);
  };

  onFinish = () => {
    const { updateDraft, projectId, handleSteps, setCanMove } = this.props;

    const payload = {
      support_levels: this.state.supportLevels.map((item) => ({
        id: item.id,
        title: item.title,
        price: item.price,
        description: item.description,
        booked: Number(item.booked || 0),
      })),
      isSupportLevelsDone: true,
      is_support_levels_done: true,
    };

    updateDraft(projectId, payload);
    setCanMove(true);
    handleSteps(7);
  };

  render() {
    const { loading } = this.props;
    const { supportLevels, modalOpen } = this.state;
    const hasReachedSupportLevelLimit =
      supportLevels.length >= MAX_SUPPORT_LEVELS;

    return (
      <Container className="" style={{ maxWidth: 600 }}>
        <Spin spinning={loading}>
          <Content>
            <HeadingBlock>
              <PageTitle>Unterstützungsstufen (optional)</PageTitle>

              <PageText>
                Unterstützungsstufen machen dein Projekt greifbar. Sie zeigen,
                was eine Sadaqah bewirken kann – real oder symbolisch – und
                helfen, sich leichter zu entscheiden.
              </PageText>

              <SmallText>
                <ul>
                  <li>Beispiel (real): 20 € = ein Schulpaket für ein Kind</li>
                  <li>
                    Beispiel (symbolisch): 50 € = ein „Tag voller Hoffnung“ für
                    eine Familie
                  </li>
                </ul>
              </SmallText>

              <SmallText>
                Tipp: Lege mehrere Stufen an – kleine Beträge für den Einstieg,
                mittlere für die meisten und höhere für alle, die bewusst mehr
                geben wollen. So findet jeder die passende Stufe.
                Selbstverständlich können Unterstützer weiterhin auch eigene
                Beträge eingeben.
              </SmallText>

              <SmallModalLink
                onClick={() => {
                  this.setState({
                    showInfoModal: true,
                  });
                }}
              >
                Beispiele anzeigen
              </SmallModalLink>
            </HeadingBlock>

            <Form
              {...formLayout}
              ref={this.formRef}
              style={{ width: '100%' }}
              name="support-levels"
              onFinish={() => this.onFinish()}
              onChange={() => this.props.setCanMove(false)}
              validateMessages={formValidateMessages}
            >
              <FormWrapper>

                  {supportLevels.length ? (
                    <SupportList>
                      {supportLevels.map((item) => (
                      <SupportCard key={item.id}>
                        <CardDeleteButton
                          type="button"
                          $visible={true}
                          onClick={() => this.removeSupportLevel(item.id)}
                        >
                          <DeleteOutlined />
                        </CardDeleteButton>

                        <SupportPrice>
                          {this.formatPrice(item.price)}
                        </SupportPrice>

                        <SupportContent>
                          <SupportTitle>{item.title}</SupportTitle>

                          {item.description && (
                            <SupportDescription>
                              {item.description}
                            </SupportDescription>
                          )}

                          <SupportBookedText>
                            {Number(item.booked || 0)} mal gebucht
                          </SupportBookedText>
                        </SupportContent>
                      </SupportCard>
                      ))}
                    </SupportList>
                  ) : (
                    <></>
                  )}


                <AddButtonWrapper>
                  {hasReachedSupportLevelLimit ? (
                    <AddLimitText>
                      Maximal {MAX_SUPPORT_LEVELS} Unterstützungsstufen können
                      hinzugefügt werden.
                    </AddLimitText>
                  ) : (
                    <AddButton type="button" onClick={this.openModal}>
                      <span>Unterstützungsstufe hinzufügen</span>
                    </AddButton>
                  )}
                </AddButtonWrapper>
              </FormWrapper>

              {supportLevels.length < 1 && (
                <SmallHelper>
                  Du kannst diesen Schritt jetzt überspringen und auch später
                  noch Unterstützungsstufen hinzufügen und bearbeiten.
                </SmallHelper>
              )}

              <FormItem>
                <SpaceBetween>
                  <SecondaryButton
                    type="button"
                    minWidth="120px"
                    onClick={this.handleReturn}
                  >
                    {this.props.editProject ? (
                      <p>Zurück zur Projektübersicht</p>
                    ) : (
                      <>
                        <ArrowLeftOutlined />
                        <p>Zurück</p>
                      </>
                    )}
                  </SecondaryButton>

                  <PrimaryButtonV2
                    type="primary"
                    htmltype="submit"
                    minWidth="113px"
                  >
                    {this.props.editProject ? (
                      <p>Speichern</p>
                    ) : (
                      <>
                        <p>Weiter</p>
                        <ArrowRightOutlined />
                      </>
                    )}
                  </PrimaryButtonV2>
                </SpaceBetween>
              </FormItem>
            </Form>
          </Content>

          <Modal
            open={modalOpen}
            footer={null}
            closable={false}
            width={732}
            centered
            destroyOnClose
            bodyStyle={{
              padding: '24px',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                marginBottom: 24,
              }}
            >
              <ModalTitle>Unterstützungsstufe hinzufügen</ModalTitle>

              <button
                type="button"
                onClick={this.closeModal}
                style={{
                  border: 'none',
                  background: 'transparent',
                  cursor: 'pointer',
                  color: '#a4a7ae',
                  fontSize: 22,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: 0,
                }}
              >
                <CloseOutlined />
              </button>
            </div>

            <Form
              ref={this.modalFormRef}
              layout="vertical"
              validateMessages={formValidateMessages}
            >
              <ModalFormContent>
                <div>
                  <Label>
                    Titel <Required>*</Required>
                  </Label>

                  <FormItem
                    name="title"
                    rules={[
                      {
                        required: true,
                        message: 'Bitte gib einen Titel ein.',
                      },
                    ]}
                    style={{ marginBottom: 0 }}
                  >
                    <AddTextArea
                      placeholder={`Titel`}
                      rows={1}
                      showCount
                      maxLength={100}
                      style={{
                        height: '40px',
                        fontSize: '16px',
                        resize: 'none',
                      }}
                      onKeyDown={(event) => {
                        this.onKeyDown(event);
                      }}
                    />
                  </FormItem>
                </div>

                <div>
                  <Label>
                    Preis <Required>*</Required>
                  </Label>

                  <PriceInputGroup>
                    <div className="currency">EUR</div>

                    <FormItem
                      name="price"
                      rules={[
                        {
                          required: true,
                          message: 'Bitte gib einen Preis ein.',
                        },
                        {
                          pattern: /^[0-9]+([,.][0-9]{1,2})?$/,
                          message: 'Bitte gib einen gültigen Preis ein.',
                        },
                      ]}
                      style={{ marginBottom: 0, flex: 1 }}
                    >
                      <StyledInput placeholder="Preis" />
                    </FormItem>
                  </PriceInputGroup>
                </div>

                <div>
                  <Label>Beschreibung</Label>

                  <FormItem name="description" style={{ marginBottom: 0 }}>
                    <StyledTextArea
                      placeholder="Beschreibung"
                      rows={5}
                      maxLength={300}
                      showCount
                    />
                  </FormItem>
                </div>
              </ModalFormContent>

              <ModalActions>
                <CancelButton type="button" onClick={this.closeModal}>
                  Abbrechen
                </CancelButton>

                <ConfirmButton type="button" onClick={this.addSupportLevel}>
                  Hinzufügen
                </ConfirmButton>
              </ModalActions>
            </Form>
          </Modal>

          <SupportInfoModal
            open={this.state.showInfoModal}
            onClose={() => {
              this.setState({
                showInfoModal: false,
              });
            }}
          />
        </Spin>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  const { project, loading, errors, currentStep } = state.projects;

  return {
    project,
    loading,
    errors,
    currentStep,
  };
};

const mapDispatchToProps = (dispatch) => ({
  handleSteps: (step) => dispatch(ProjectsActions.handleSteps(step)),

  updateDraft: (projectId, project, currentStep, submit) =>
    dispatch(
      ProjectsActions.updateDraft(projectId, project, currentStep, submit)
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(SupportLevels);
